<div class="flex flex-col flex-auto md:w-1/3">
	<div class="flex items-center space-x-3">
		<i class="w-4 text-center spreeng spreeng-email p-color-primary"></i>
		<span class="leading-loose break-all">{{ user?.emailAddress }}</span>
	</div>
	<div class="flex items-center space-x-3">
		<i class="w-4 text-center fas fa-phone p-color-primary"></i>
		<span class="leading-loose break-all">{{ user?.phoneNumber || '-' }}</span>
	</div>
	<div class="flex items-center space-x-3">
		<i class="w-4 text-center far fa-calendar p-color-primary"></i>
		<span class="leading-loose break-words">
			<ng-container *ngIf="user?.metadata.birthDate">
				{{ user?.metadata.birthDate | date: 'mediumDate':null:locale }}
			</ng-container>
			<ng-container *ngIf="!user?.metadata.birthDate">-</ng-container>
		</span>
	</div>
	<div class="flex items-center space-x-3">
		<i class="w-4 text-center spreeng spreeng-linkedin p-color-primary"></i>
		<a
			*ngIf="user?.metadata.linkedInUrl"
			[href]="user?.metadata.linkedInUrl"
			class="leading-loose break-words"
			target="_blank"
		>
			{{ 'presentation.app.common.user.metadata.linkedIn.link' | translate }}
		</a>
		<span *ngIf="!user?.metadata.linkedInUrl">-</span>
	</div>
</div>
<div class="flex-auto w-1/3">
	<div class="flex items-center space-x-3">
		<i class="w-4 text-center spreeng spreeng-home p-color-primary"></i>
		<span class="leading-loose break-words">
			{{ user?.metadata.livingAddress || '-' }}
		</span>
	</div>
	<div class="flex items-center space-x-3">
		<i class="w-4 text-center fas fa-map-marker-alt p-color-primary"></i>
		<span class="leading-loose break-words">
			{{ user?.metadata.originAddress || '-' }}
		</span>
	</div>
	<div class="flex items-center space-x-3">
		<i class="w-4 text-center far fa-calendar-check p-color-primary"></i>
		<span
			[translate]="'presentation.app.common.user.metadata.creation'"
			[translateParams]="{
				date: (user?.creationTimestamp | date: 'longDate':null:locale)
			}"
			class="leading-loose break-words"
		></span>
	</div>
	<div class="flex items-center space-x-3">
		<i class="w-4 text-center fas fa-user-graduate p-color-primary"></i>
		<span class="leading-loose break-words">{{ user?.lastReference }}</span>
	</div>
</div>
